// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function () {
  // Get the header element
  const header = document.querySelector('.header');
  
  // Check if header exists
  if (!header) {
    console.error('Header element not found. Please ensure the .header class exists in the DOM.');
    return;
  }

  // Check for scroll-trigger class to avoid animations.js conflict
  if (header.classList.contains('scroll-trigger')) {
    console.warn('Header has scroll-trigger class, which may cause conflicts with animations.js. Consider removing it.');
  }

  // Define mobile breakpoint (matches CSS media query)
  const mobileBreakpoint = 992;

  // Variable to store the last scroll position
  let lastScrollTop = 0;

  // Function to handle scroll events
  function handleScroll() {
    // Only proceed if on mobile
    if (window.innerWidth >= mobileBreakpoint) {
      header.classList.remove('header--hidden'); // Ensure header is visible on desktop
      return;
    }

    // Get the current scroll position
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Always show header at the top of the page
    if (scrollTop <= 0) {
      header.classList.remove('header--hidden');
      console.log('At top, header visible (mobile)');
    } else if (scrollTop > lastScrollTop) {
      // Scrolling down: hide header
      header.classList.add('header--hidden');
      console.log('Scrolling down, header hidden (mobile)');
    } else {
      // Scrolling up: show header
      header.classList.remove('header--hidden');
      console.log('Scrolling up, header visible (mobile)');
    }

    // Update last scroll position
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Prevent negative scroll values
  }

  // Debounce function to limit how often a function runs
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Function to initialize or remove scroll listener based on viewport
  function setupScrollListener() {
    // Remove any existing scroll listener to prevent duplicates
    window.removeEventListener('scroll', debouncedScrollHandler);

    // Add scroll listener only if on mobile
    if (window.innerWidth < mobileBreakpoint) {
      window.addEventListener('scroll', debouncedScrollHandler);
      console.log('Scroll listener added (mobile)');
    } else {
      header.classList.remove('header--hidden'); // Ensure header is visible on desktop
      console.log('Scroll listener not added (desktop)');
    }
  }

  // Create debounced scroll handler
  const debouncedScrollHandler = debounce(handleScroll, 50);

  // Create debounced resize handler
  const debouncedResizeHandler = debounce(setupScrollListener, 100);

  // Initialize scroll listener
  setupScrollListener();

  // Re-evaluate on window resize
  window.addEventListener('resize', debouncedResizeHandler);

  // Log initialization for debugging
  console.log('Header scroll script initialized');
});